module.exports = __webpack_public_path__ + "static/media/Cats eyes 06_FRANSKA-mixdown.f59f567e.mp3";